import React, { FC } from "react";

interface PinProps {
  size: number;
  category?: string;
}
const Pin: FC<PinProps> = ({ size }) => {
  return (
    <svg
      height={size}
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer"
    >
      <path
        d="M7.5 9C8.01562 9 8.45703 8.82375 8.82422 8.47125C9.19141 8.11875 9.375 7.695 9.375 7.2C9.375 6.705 9.19141 6.28125 8.82422 5.92875C8.45703 5.57625 8.01562 5.4 7.5 5.4C6.98438 5.4 6.54297 5.57625 6.17578 5.92875C5.80859 6.28125 5.625 6.705 5.625 7.2C5.625 7.695 5.80859 8.11875 6.17578 8.47125C6.54297 8.82375 6.98438 9 7.5 9ZM7.5 18C4.98438 15.945 3.10547 14.0363 1.86328 12.2738C0.621094 10.5113 0 8.88 0 7.38C0 5.13 0.753906 3.3375 2.26172 2.0025C3.76953 0.6675 5.51562 0 7.5 0C9.48438 0 11.2305 0.6675 12.7383 2.0025C14.2461 3.3375 15 5.13 15 7.38C15 8.88 14.3789 10.5113 13.1367 12.2738C11.8945 14.0363 10.0156 15.945 7.5 18Z"
        fill="#000000"
      />
      <rect x="3" y="3" width="9" height="7" fill="#000000" />
      <path
        d="M7.60156 8C7.80781 8 7.98438 7.92167 8.13125 7.765C8.27813 7.60833 8.35156 7.42 8.35156 7.2C8.35156 6.98 8.27813 6.79167 8.13125 6.635C7.98438 6.47833 7.80781 6.4 7.60156 6.4C7.39531 6.4 7.21875 6.47833 7.07188 6.635C6.925 6.79167 6.85156 6.98 6.85156 7.2C6.85156 7.42 6.925 7.60833 7.07188 7.765C7.21875 7.92167 7.39531 8 7.60156 8ZM7.60156 12C6.59531 11.0867 5.84375 10.2383 5.34688 9.455C4.85 8.67167 4.60156 7.94667 4.60156 7.28C4.60156 6.28 4.90312 5.48333 5.50625 4.89C6.10938 4.29667 6.80781 4 7.60156 4C8.39531 4 9.09375 4.29667 9.69688 4.89C10.3 5.48333 10.6016 6.28 10.6016 7.28C10.6016 7.94667 10.3531 8.67167 9.85625 9.455C9.35938 10.2383 8.60781 11.0867 7.60156 12Z"
        fill="white"
      />
    </svg>
  );
};

export default React.memo(Pin);
